// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".options-col[data-v-0693bd7c]{height:100%;width:180px;background-color:#fcfcfc;border-right:1px solid #dadada}", ""]);
